import { render, staticRenderFns } from "./CoApplication.vue?vue&type=template&id=5cbfde80&scoped=true&"
import script from "./CoApplication.vue?vue&type=script&lang=js&"
export * from "./CoApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbfde80",
  null
  
)

export default component.exports